import { linkElement } from './link.element';
import { PublicRecommendationItemDto } from '../../dto/recs.dto';
import { HtmlElementContext } from '../../types';

type Props =  Partial<Pick<HTMLHtmlElement, | 'className'>> & {
  subtitle: PublicRecommendationItemDto['subtitle'],
};

export const subtitleElement = (props: Props, context: HtmlElementContext): HTMLElement | null => {
  const element = context.dom.createElement('span');
  element.className = props.className ?? context.stylesheet.classes['listItemSubtitle'];

  if (
    typeof props.subtitle === 'string'
    && props.subtitle.length > 0
  ) {
    element.textContent = props.subtitle;

    return element;
  }

  if (
    typeof props.subtitle === 'object'
    && props.subtitle?.type === 'string'
    && 'content' in props.subtitle
    && typeof props.subtitle.content === 'string'
    && props.subtitle.content.length > 0
  ) {
    element.textContent = props.subtitle.content ?? '';

    return element;
  }

  if (
    typeof props.subtitle === 'object'
    && props.subtitle?.type === 'link'
    && 'url' in props.subtitle
    && typeof props.subtitle.content === 'string'
    && props.subtitle.content.length > 0
  ) {
    element.appendChild(
      linkElement({
        href: props.subtitle.url ?? '',
        textContent: props.subtitle.content,
        ...context.adSlot.getSettings().getLinkProperties()?.subtitle,
      }, context),
    );

    return element;
  }

  return null;
}
